import React, { useRef, useEffect } from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";

const TripsSection = ({ categories = [] }) => {
  const scrollRefs = useRef([]);

  const scrollLeft = (index) => {
    scrollRefs.current[index]?.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = (index) => {
    scrollRefs.current[index]?.scrollBy({ left: 350, behavior: "smooth" });
  };

  const navigate = useNavigate();

  return (
    <>
      {categories.map((category, index) => (
        <Container className="my-5 position-relative" key={category.id}>
          <h2 className="text-center mb-4">{category.title}</h2>
          <div className="position-relative d-flex align-items-center">
            {/* Left Arrow */}
            <Button
              variant="dark"
              className="position-absolute d-none d-lg-flex align-items-center justify-content-center"
              style={{
                zIndex: 10,
                left: "-60px",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                transition: "0.3s",
              }}
              onClick={() => scrollLeft(index)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#ff6600")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "black")}
            >
              <i
                className="bi bi-chevron-left"
                style={{ fontSize: "24px" }}
              ></i>
            </Button>

            {/* Scrollable Cards */}
            <div className="w-100 overflow-hidden px-5">
              <Row
                className="flex-nowrap overflow-auto"
                ref={(el) => (scrollRefs.current[index] = el)}
                style={{
                  scrollBehavior: "smooth",
                  display: "flex",
                  padding: "10px 0",
                  whiteSpace: "nowrap",
                }}
              >
                {category.trips.map((trip, idx) => (
                  <Col
                    key={idx}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className="d-flex"
                    style={{ flex: "0 0 25%", minWidth: "250px" }}
                  >
                    <Card
                      className="m-2 shadow-lg w-100"
                      style={{ maxWidth: "280px", cursor: "pointer" }}
                      onClick={() => navigate(`/trips/${trip.path}`)}
                    >
                      <Card.Img
                        variant="top"
                        src={trip.imageUrl}
                        className="img-fluid w-100"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <Card.Body>
                        <Card.Title
                          className="text-truncate"
                          style={{ maxWidth: "100%" }}
                        >
                          {trip.title}
                        </Card.Title>
                        <Card.Text>
                          {trip.originalPrice && (
                            <del>
                              ₹{Number(trip.originalPrice).toLocaleString()}
                            </del>
                          )}{" "}
                          <strong>
                            ₹{Number(trip.price).toLocaleString()}
                          </strong>
                        </Card.Text>
                        <Card.Text>⏳ {trip.duration}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>

            {/* Right Arrow */}
            <Button
              variant="dark"
              className="position-absolute d-none d-lg-flex align-items-center justify-content-center"
              style={{
                zIndex: 10,
                right: "-60px",
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                transition: "0.3s",
              }}
              onClick={() => scrollRight(index)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#ff6600")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "black")}
            >
              <i
                className="bi bi-chevron-right"
                style={{ fontSize: "24px" }}
              ></i>
            </Button>
          </div>
        </Container>
      ))}
    </>
  );
};

export default TripsSection;
